import {BaseWrapper} from '../../../../allkey/framework/parameters/BaseWrapper';
import {MetaProcess} from '../message/MetaProcess';
import {MetaProcessCriteria} from './MetaProcessCriteria';
import {MetaProcessScenario} from './MetaProcessScenario';

export class MetaProcessWrapper extends BaseWrapper<MetaProcess, MetaProcessCriteria, MetaProcessScenario>  {}

